/* istanbul ignore file */
export * from './StickyArea';
